import { URL } from '../constants/api'
import axios from 'axios'


var cancelToken = {
}

axios.interceptors.response.use(undefined, err => {
  //if (err.status === 500 && err.config) {
  if (err.config) {
    return new Promise(function(resolve, reject) {
      setTimeout(()=>resolve(axios(err.config)), 2000)
    })
  }
  throw err
})

const requestAxios = function(url, idCancelToken) {
  if (cancelToken[idCancelToken])
    cancelToken[idCancelToken].cancel()
  cancelToken[idCancelToken] = axios.CancelToken.source()
  return axios({
    url: url,
    cancelToken: cancelToken[idCancelToken].token,
  }).then(data=>data.data)
}

export default {
  fetchNeighborhoods() {
    var ENDPOINT = URL + 'properties/neighborhoodFronts'
    return requestAxios(ENDPOINT, 'fetchNeighborhoods')
  },
  fetchVisibleNeihborhoods() {
    var ENDPOINT = URL + 'properties/neighborhoodFronts?only_visible=' + true
    return requestAxios(ENDPOINT, 'fetchVisibleNeihborhoods')
  },
  fetchNeihborhoodsDetail(id) {
    var ENDPOINT = URL + 'properties/neighborhoodFronts/' + id
    return requestAxios(ENDPOINT, 'fetchNeihborhoodsDetail')
  },
  totalSaleResults() {
    var arrayId = []
    arrayId.push(1)
    var params = {'operation_type_id': arrayId}
    var ENDPOINT = URL + 'properties/search/?q=' + JSON.stringify(params)
    return requestAxios(ENDPOINT, 'totalSaleResults')
  },
  totalRentResults() {
    var arrayId = []
    arrayId.push(2)
    var params = {'operation_type_id': arrayId}
    var ENDPOINT = URL + 'properties/search/?q=' + JSON.stringify(params)
    return requestAxios(ENDPOINT, 'totalRentResults')
  },
  totalNeighborhoodRentResults(id) {
    var arrayId = []
    var arrayN = []
    arrayId.push(2)
    arrayN.push(parseInt(id))
    var params = {'operation_type_id': arrayId, 'neighborhoodFront_id': arrayN}
    var ENDPOINT = URL + 'properties/search/?q=' + JSON.stringify(params)
    return requestAxios(ENDPOINT, 'totalNeighborhoodRentResults')
  },
  totalNeighborhoodSaleResults(id) {
    var arrayId = []
    var arrayN = []
    arrayId.push(1)
    arrayN.push(parseInt(id))
    var params = {'operation_type_id': arrayId, 'neighborhoodFront_id': arrayN}
    var ENDPOINT = URL + 'properties/search/?q=' + JSON.stringify(params)
    return requestAxios(ENDPOINT, 'totalNeighborhoodSaleResults')
  }
}


// WEBPACK FOOTER //
// ./src/api/neighborhoodFronts.js